import CookieManager from "./../utilities/cookiemanager";

export default class FontSizeService {
  DOMContainer = null;
  options = null;

  constructor(options) {
    this.options = options;
    this.init();
  }

  init() {
    const cookie = CookieManager.getCookie(CookieManager.cookieKeys.FONTSIZE);
    let size = this.options.rootFontSize;
    if (cookie) {
      size = JSON.parse(cookie).size;
      if (size < 3) {
        // Case for old cookies
        size = this.options.rootFontSize;
      }
    }
    document.documentElement.setAttribute("style", `font-size: ${size}px;`);
  }

  increase() {
    let fontSize = parseInt(document.documentElement.style.fontSize);
    if (fontSize < this.options.maxfontSize) {
      fontSize += this.options.fontSizeStep;
    } else {
      fontSize = 10;
    }
    CookieManager.createCookie(
      CookieManager.cookieKeys.FONTSIZE,
      JSON.stringify({
        size: fontSize,
      })
    );
    document.documentElement.setAttribute("style", `font-size: ${fontSize}px`);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/fontSizeService.js